// Which roles may access each route. Mirrors the visibility rules already
// encoded in components/layout/Sidebar.jsx's getMenuGroups() - keep in sync.
// A path not listed here is accessible to any authenticated role.
export const ROUTE_ROLES = {
  '/dashboard': ['ADMIN'],
  '/dashboard/tl': ['ADMIN', 'TL'],
  '/dashboard/trainer': ['ADMIN', 'TRAINER'],
  '/schools': ['ADMIN', 'TL', 'TRAINER'],
  '/schools/search': ['ADMIN', 'TL', 'TRAINER'],
  '/schools/demo': ['ADMIN', 'TL'],
  '/schools/billed': ['ADMIN', 'TL'],
  '/schools/not-billed': ['ADMIN', 'TL'],
  '/schools/expired': ['ADMIN', 'TL'],
  '/schools/detail': ['ADMIN', 'TL'],
  '/training': ['ADMIN', 'TL', 'TRAINER'],
  '/sop': ['ADMIN', 'TL', 'TRAINER'],
  '/announcements': ['ADMIN', 'TL'],
  '/product-list': ['ADMIN', 'TL'],
  '/billdesk': ['ADMIN', 'TL'],
  '/transaction-panel': ['ADMIN', 'TL'],
  '/analytics': ['ADMIN'],
  '/contracts': ['ADMIN'],
  '/renewals': ['ADMIN'],
  '/support': ['ADMIN', 'TL'],
  '/support-chat': ['ADMIN', 'TL'],
  '/whatsapp': ['ADMIN', 'TL'],
  '/whatsapp/queue': ['ADMIN', 'TL'],
  '/whatsapp/inbox': ['ADMIN', 'TL'],
  '/whatsapp/accounts': ['ADMIN', 'TL'],
  '/whatsapp/price-plans': ['ADMIN', 'TL'],
  '/whatsapp/templates': ['ADMIN', 'TL'],
  '/whatsapp/templates/master': ['ADMIN', 'TL'],
  '/whatsapp/reports': ['ADMIN', 'TL'],
  '/whatsapp/audit': ['ADMIN', 'TL'],
  '/school-accounts': ['ADMIN'],
  '/login-logs': ['ADMIN'],
  '/school-query': ['ADMIN', 'TL'],
  '/school-groups': ['ADMIN', 'TL'],
  '/telecaller': ['ADMIN', 'TL'],
  '/ai-agents': ['ADMIN'],
  '/referrals': ['ADMIN', 'TL'],
  '/promoters': ['ADMIN', 'TL'],
  '/validation': ['ADMIN', 'TL'],
  '/manage-website': ['ADMIN', 'TL'],
  // detail path uses same role gate via guardedRoute('/manage-website', ...)
  '/settings': ['ADMIN', 'TL', 'TRAINER'],
};

export const dashboardPathForRole = (role) => {
  const normalized = (role || 'ADMIN').toUpperCase();
  if (normalized === 'TL') return '/dashboard/tl';
  if (normalized === 'TRAINER') return '/dashboard/trainer';
  return '/dashboard';
};
